/* sw-gift-progress — free-sample status card for the UpCart drawer + cart page.
   Fed by sw-alia-gift-add's `sw-gift:state` events / window.__swGiftState.
   Shadow DOM (no theme CSS bleed). JS-mounted; UpCart renders in an open
   shadow root on #upCart (React) that wipes foreign nodes on re-render —
   MutationObservers on body AND that shadow root re-mount. No core file edits.
   Binary unlock (no spend threshold): any core Swoleys product qualifies.
   REVERSIBLE: delete this asset + the loader line in sw-alia-gift-add. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  if (customElements.get('sw-gift-progress')) return;

  var GIFT_NAME = 'FREE 12-Serve Sample';

  class SwGiftProgress extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;
      var root = this.attachShadow({ mode: 'open' });
      root.innerHTML =
        '<style>' +
        ':host { display:none; font-family: Montserrat, ui-sans-serif, system-ui, sans-serif; }' +
        '.wrap { background:#FFFFFF; border:2px solid #000; border-radius:12px; box-shadow:3px 3px 0 0 #000; padding:10px 14px; margin:10px 12px; }' +
        '.msg { font-size:13px; line-height:1.35; color:#000; font-weight:700; margin:0; }' +
        '.msg b { color:#8C52FF; }' +
        '.wrap.unlocked { background:#CCFF00; }' +
        '.wrap.unlocked .msg b { color:#000; }' +
        '</style>' +
        '<div class="wrap"><p class="msg"></p></div>';
      this._wrap = root.querySelector('.wrap');
      this._msg = root.querySelector('.msg');
      this.render(window.__swGiftState || { mode: 'hidden' });
    }
    render(state) {
      if (!this._wrap) return;
      if (!state || state.mode === 'hidden') { this.style.display = 'none'; return; }
      this.style.display = 'block';
      if (state.mode === 'unlocked') {
        this._wrap.classList.add('unlocked');
        this._msg.innerHTML = '🎁 <b>' + GIFT_NAME + '</b> added to your order — $0.00';
      } else {
        this._wrap.classList.remove('unlocked');
        this._msg.innerHTML = 'Your <b>' + GIFT_NAME + '</b> unlocks with any Swoleys product in the cart';
      }
    }
  }
  customElements.define('sw-gift-progress', SwGiftProgress);

  function upcartRoot() {
    var up = document.getElementById('upCart');
    return up && up.shadowRoot ? up.shadowRoot : null;
  }

  function mountInto(parent, beforeEl) {
    if (!parent || parent.querySelector('sw-gift-progress')) return;
    var el = document.createElement('sw-gift-progress');
    parent.insertBefore(el, beforeEl);
    el.render && el.render(window.__swGiftState || { mode: 'hidden' });
  }

  /* Mount points: top of the UpCart drawer body (shadow DOM), top of the Dawn
     drawer items if that cart type is ever enabled, above the cart page footer. */
  function mountAll() {
    var root = upcartRoot();
    if (root) {
      var products = root.querySelector('.upcart-products-section');
      if (products) mountInto(products.parentNode, products);
    }
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems) mountInto(drawerItems.parentNode, drawerItems);
    var cartFooter = document.querySelector('#main-cart-footer');
    if (cartFooter) mountInto(cartFooter.parentNode, cartFooter);
  }

  function allMounts() {
    var list = Array.prototype.slice.call(document.querySelectorAll('sw-gift-progress'));
    var root = upcartRoot();
    if (root) list = list.concat(Array.prototype.slice.call(root.querySelectorAll('sw-gift-progress')));
    return list;
  }

  function renderAll(state) {
    allMounts().forEach(function (el) {
      el.render && el.render(state);
    });
  }

  document.addEventListener('sw-gift:state', function (e) { mountAll(); renderAll(e.detail); });

  var moDebounce = null;
  function onMutate() {
    clearTimeout(moDebounce);
    moDebounce = setTimeout(function () { mountAll(); renderAll(window.__swGiftState || { mode: 'hidden' }); }, 150);
  }
  try {
    new MutationObserver(onMutate).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
  /* UpCart's shadow root may not exist yet at load — attach when it appears. */
  var shadowObserved = false;
  function watchShadow() {
    if (shadowObserved) return;
    var root = upcartRoot();
    if (!root) return;
    try {
      new MutationObserver(onMutate).observe(root, { childList: true, subtree: true });
      shadowObserved = true;
    } catch (e) {}
  }
  watchShadow();
  var shadowPoll = setInterval(function () {
    watchShadow();
    if (shadowObserved) clearInterval(shadowPoll);
  }, 1000);
  setTimeout(function () { clearInterval(shadowPoll); }, 30000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }
})();
